import { render, staticRenderFns } from "./BusForm.vue?vue&type=template&id=0317f298"
import script from "./BusForm.vue?vue&type=script&lang=ts"
export * from "./BusForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports